export default "__VITE_ASSET__CxetKIR3__"